/**
 * Workflow admin barrel aggregator
 * Combines all workflow-related handlers
 */

import type { UseAdminAppReturn } from "./useAdminApp";
import { useWorkflowProxyAdmin, type WorkflowProxyAdminHandler } from "./workflow/useWorkflowProxyAdmin";

export interface WorkflowAdminHandler {
  proxy: WorkflowProxyAdminHandler;
}

export function useWorkflowAdmin(adminApp: UseAdminAppReturn): WorkflowAdminHandler {
  const proxy = useWorkflowProxyAdmin(adminApp);

  return {
    proxy,
  };
}

// Re-export types for convenience
export type { WorkflowProxyAdminHandler };

